import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  type ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material';

export const ToggleButtonGroup = MuiToggleButtonGroup;
export type ToggleButtonGroupProps = MuiToggleButtonGroupProps;

export {ToggleButton, type ToggleButtonProps} from './ToggleButton';
